"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUserApiClient = void 0;
const shared_logger_1 = require("@aladin/shared-logger");
const shared_common_sdk_1 = require("@aladin/shared-common-sdk");
function createUserApiClient(options) {
    const logger = options.logger ?? shared_logger_1.NOOP_LOGGER;
    const client = (0, shared_common_sdk_1.createAxiosClient)(options.userApiHost, {
        accessTokenSource: options.accessTokenSource,
    });
    async function sendInvite(params) {
        try {
            await client.post('/v1/invite', params.request);
        }
        catch (err) {
            logger.debug('%s', err.stack);
            (0, shared_common_sdk_1.handleError)(err);
        }
    }
    async function registerUser(params) {
        try {
            const response = await client.post('/v2/users', params.newUser);
            const location = response.headers?.location || '';
            const matches = location.match(/\/v2\/users\/([0-9]*)/) || [];
            if (matches.length > 0) {
                const userId = matches[1];
                return userId && +userId || undefined;
            }
        }
        catch (err) {
            logger.debug('%s', err.stack);
            (0, shared_common_sdk_1.handleError)(err);
        }
    }
    async function fetchUsersByPartnerIdAndMembershipNumber(partnerId, membershipNumber, onlyConfirmedProfiles = true) {
        try {
            const params = { all_profiles: !onlyConfirmedProfiles };
            const response = await client.get(`/v1/partners/${partnerId}/memberships/${membershipNumber}/users`, { params });
            return response.data;
        }
        catch (err) {
            logger.debug('%s', err.stack);
            (0, shared_common_sdk_1.handleError)(err);
        }
    }
    async function createUser(email, hasAcceptedFarmerCgu) {
        try {
            const response = await client.post('/v1/users', {
                email,
                has_accepted_farmer_cgu: hasAcceptedFarmerCgu
            });
            return response.data;
        }
        catch (err) {
            logger.debug('%s', err.stack);
            (0, shared_common_sdk_1.handleError)(err);
        }
    }
    async function createConfirmedProfile(userId, membershipNumber, partnerId) {
        try {
            const response = await client.post('/v1/confirmed-profiles', {
                user_id: userId,
                membership_number: membershipNumber,
                partner_id: partnerId,
            });
            return response.data;
        }
        catch (err) {
            logger.debug('%s', err.stack);
            (0, shared_common_sdk_1.handleError)(err);
        }
    }
    async function setCurrentCustomer(request) {
        try {
            await client.post('/v1/users/me/currentCustomer', request);
            return;
        }
        catch (err) {
            logger.debug('%s', err.stack);
            (0, shared_common_sdk_1.handleError)(err);
        }
    }
    return {
        sendInvite,
        registerUser,
        fetchUsersByPartnerIdAndMembershipNumber,
        createUser,
        createConfirmedProfile,
        setCurrentCustomer
    };
}
exports.createUserApiClient = createUserApiClient;
//# sourceMappingURL=data:application/json;base64,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